import { Component, Container } from "@mcleod/components";

export class ActionAddComponent {
  component: Component;
  parent: Container;

  constructor(component: Component, parent: Container) {
    this.component = component;
    this.parent = parent;
  }

  execute() {
    if (this.parent != null)
      this.parent.add(this.component);
  }

  undo() {
    this.parent.remove(this.component);
  }

  toString() {
    return "Add " + this.component.constructor.name;
  }
}
